import styled from 'styled-components';
import { MDBListGroup } from 'mdb-react-ui-kit';

export const PlayerListGroup = styled(MDBListGroup)`
    border-radius: 0;
    background: transparent;
`;

export const TeamCard = styled.div`
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 12px;
    background: rgba(255,255,255,0.03);
    overflow: hidden;
    margin-bottom: 0.5rem;
`;

export const PositionHeader = styled.div`
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #94a3b8;
    background: rgba(255,255,255,0.04);
    padding: 0.45rem 0.85rem;
    border-top: 1px solid rgba(255,255,255,0.07);
    border-bottom: 1px solid rgba(255,255,255,0.07);
    letter-spacing: 0.08em;
    &:first-of-type { margin-top: 0; border-top: none; }
`;

export const PlayerItem = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.55rem 0.85rem;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    transition: background 0.15s ease;
    background: transparent;
    &:last-child { border-bottom: none; }
    &:hover { background: rgba(59,130,246,0.1); }

    .player-name {
        font-size: 0.82rem;
        font-weight: 600;
        color: #e2e8f0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .chevron {
        color: #4b5563;
        font-size: 0.85rem;
        transition: transform 0.15s ease, color 0.15s ease;
    }
    &:hover .chevron { color: #93c5fd; transform: translateX(3px); }
`;
